import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
import CustomImage from "../CustomImage/CustomImage";

function ParentCategory() {
  const [parentcat, setParentCat] = useState([]);
  const [selectedFile, setSelectdFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [deleteParentCategory, setDeleteParentCategory] = useState([]);
  const [parentCategoryGroups, setParentCategoryGroups] = useState([]);
  const [parentCategoryName, setParentCategoryName] = useState("");
  const [notice, setNotice] = useState("");
  const [selectedItemId, setSelectedItemId] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [status, setStatus] = useState("");
  const [InquiryForm, setInquiryForm] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const getParentCategoryGroups = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategoryGroup/GetParentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };
  console.log("selectedGroup", selectedGroup);
  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/AllParentcategory`
      );
      setParentCat(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteParent = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ParentCategory/Parentcategory/${_id}`
        );
        console.log("DELETE Response:", response);

        setDeleteParentCategory(
          deleteParentCategory.filter((item) => item._id !== _id)
        );
        getParentCategory();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };
  console.log("InquiryForm",InquiryForm)
  const AddParentCategory = async (event) => {
    event.preventDefault();
    if (!selectedGroup) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "please select parent category group",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("PCName", parentCategoryName);
      formData.append("PCNotice", notice);
      formData.append("Status", status);
      formData.append("InquiryForm", InquiryForm == true ? 1 : 0);

      // selectedGroup &&
      if (selectedGroup.length > 0) {
        selectedGroup?.forEach((groupId, index) => {});
      }
      formData.append(`PCGroup`, selectedGroup.value);

      // let a = selectedGroup.map((item) => item.value);
      // formData.append(`PCGroup`, groupId.value);

      // Only append the image if a new image has been selected
      if (selectedFile) {
        formData.append("PCimage", selectedFile);
      }

      let response;
      if (selectedItemId) {
        // Update existing item
        response = await privateRequest.put(
          `ParentCategory/Parentcategory/${selectedItemId}`,
          formData
        );
      } else {
        // Add new item
        response = await privateRequest.post(
          `ParentCategory/Parentcategory`,
          formData
        );
      }

      console.log("POST/PUT Response:", response);
      getParentCategory();
      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: selectedItemId
          ? "Parent updated successfully!"
          : "Parent added successfully!",
      });
      console.log("Add Response:", response);
      setParentCategoryName("");
      setSelectdFile("");
      setImagePreview("");
      setNotice("");
      setStatus("");
      setInquiryForm(0);
      setSelectedGroup([]);
      setSelectedItemId();
      getParentCategory();
      setShowModal(false);
    } catch (error) {
      if (error.TypeError == "selectedGroup.forEach is not a function") {
        console.log("fdndlf");
      }
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
      console.error("Add Error:", error);
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectdFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    getParentCategory();
    getParentCategoryGroups();
  }, []);

  console.log("selectedGroup", selectedGroup);
  return (
    <>
      {parentcat.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Parent Category</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setSelectedItemId("");
                        setParentCategoryName("");
                        setNotice("");
                        setImagePreview("");
                        setStatus("");
                        setInquiryForm(0);
                        setSelectdFile("");
                        setSelectedGroup("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">
                              <i className="fa fa-image"></i>
                            </th>
                            <th scope="col" style={{ width: "200px" }}>
                              Group
                            </th>
                            <th scope="col">P Cat Name</th>
                            <th scope="col">Notice</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parentcat.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.PCimage && (
                                  <img
                                    src={`${Image_URL}${item?.PCimage}`}
                                    alt="Category Image"
                                    className="rounded-pill"
                                    height="50"
                                    width="50"
                                  />
                                )}
                              </td>
                              <td className="align-center">
                                <span className="mr-1 badge badge-primary">
                                  {item?.PCGroup?.PCGName}
                                </span>
                              </td>

                              <td className="align-center">{item?.PCName}</td>
                              <td className="align-center">{item.PCNotice}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status === "0"
                                      ? "badge-danger"
                                      : "badge-primary"
                                  }`}
                                >
                                  {item?.Status === "1" ? "Active" : "Inactive"}
                                </span>
                              </td>

                              <td className="align-center">
                                <p className="mb-0">
                                  {item?.PCCreatedBy?.name}
                                </p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>

                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      console.log("item of pcgroup", item);
                                      let a = {
                                        label: item?.PCGroup?.PCGName,
                                        value: item?.PCGroup?._id,
                                      };
                                      setSelectedItemId(item._id);
                                      setParentCategoryName(item?.PCName);
                                      setNotice(item?.PCNotice);
                                      setStatus(item?.Status);
                                      setInquiryForm(item?.InquiryForm);
                                      setSelectdFile(item.PCimage);
                                      setImagePreview(
                                        Image_URL + item?.PCimage
                                      );
                                      setSelectedGroup(a);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteParent(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addAreaModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Parent Category
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowModal(false);
                  setSelectedItemId("");
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddParentCategory}>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Select P Group Name</label>

                      <Select
                        isClearable
                        value={selectedGroup}
                        options={parentCategoryGroups.map((group) => ({
                          value: group._id,
                          label: group.PCGName,
                        }))}
                        onChange={(selectedOptions) => {
                          console.log("selectedOptions", selectedOptions);
                          setSelectedGroup(selectedOptions);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">P Category Name</label>
                      <input
                        type="text"
                        value={parentCategoryName}
                        onChange={(e) => setParentCategoryName(e.target.value)}
                        id="inputName"
                        className="form-control"
                        placeholder="P Category Name"
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Notice</label>
                      <input
                        type="text"
                        value={notice}
                        onChange={(e) => setNotice(e.target.value)}
                        id="inputNotice"
                        className="form-control"
                        placeholder="Notice"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 d-flex justify-content-start align-items-center">
                    <div className="custom-control custom-control-inline custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="ckb1"
                        name="spCommentShow"
                        checked={InquiryForm == 1 ? true : false}
                        value=""
                        onChange={(e) => {
                          setInquiryForm(!InquiryForm);
                        }}
                      />

                      <label className="custom-control-label" htmlFor="ckb1">
                        InquiryForm
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4">
                    <CustomImage
                      setImagePreview={setImagePreview}
                      imagePreview={imagePreview}
                      setSelectedFile={setSelectdFile}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 mt-3">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItemId ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default ParentCategory;
